module.exports = __webpack_public_path__ + "static/img/junyu_phone.5f5d6822.png";